<script setup lang="ts">
import { RouterView } from 'vue-router'
import ToastContainer from './components/ToastContainer.vue'
</script>

<template>
  <RouterView />
  <ToastContainer />
</template>

<style scoped>
</style>
